var map = {
	"./piece_2000.png": "7m0M",
	"./piece_2001.png": "P0Rg",
	"./piece_2002.png": "0u2X",
	"./piece_2100.png": "Q8il",
	"./piece_2101.png": "U/3u",
	"./piece_2102.png": "qlGv",
	"./piece_level0.png": "Aq6S",
	"./piece_level1.png": "/8f6",
	"./piece_level2.png": "HqFa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "O0hE";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece ^\.\/piece_.*\.png$
// module id = O0hE
// module chunks = 0